import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import ToolsGeneralContent from '@v2/pages/machines/modules/now/components/Tools/components/ToolsGeneralContent';
import { connect } from 'react-redux';
import { productionBatchStatistics } from '@reducers/statistics';
import { PANEL_VIEW_MODE_WIDTH, SCREEN_PADDING_HORIZONTAL_FOR_ITEM } from '@v2/pages/common/constants/base.constants';
import { getNCFileById } from '@reducers/manufacture';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { useBatchDetails } from '@v2/pages/common/hooks/useBatchDetails';
import { View } from 'react-native';
import { scale } from '@components/frame';
import { isWeb } from '@helpers';

interface BatchDetailsToolsProps {}

const BatchDetailsToolsComponent: FC<BatchDetailsToolsProps> = ({
  clearTools,
  getNCFileById,
  getTools,
  productionBatchStatistics,
  updateHeaderConfig,
  toolsLoaded,
}) => {
  const title = useTitle();

  const { refetchTools } = useBatchDetails({
    clearTools,
    getNCFileById,
    getTools,
    productionBatchStatistics,
    updateHeaderConfig,
  });

  return (
    <DetailsPageWrapper title={title.tool}>
      <View style={{ flex: 1, paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL_FOR_ITEM) }}>
        <ToolsGeneralContent
          loading={!toolsLoaded}
          maxDetailsWidth={PANEL_VIEW_MODE_WIDTH}
          bg={!isWeb ? 'Background/Light/Field on Panel' : 'Background/Light/Field'}
          refetchTools={refetchTools}
        />
      </View>
    </DetailsPageWrapper>
  );
};

const BatchDetailsTools = connect(({ clampingTools: { loaded } }) => ({ toolsLoaded: loaded }), {
  clearTools,
  getNCFileById,
  getTools,
  productionBatchStatistics,
  updateHeaderConfig,
})(BatchDetailsToolsComponent);

export { BatchDetailsTools };
